
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { FileUrl } from '@/utils/commons'
import { UserModule } from '@/store/modules/user'
import setting from '@/settings'
import DictSelect from '@/components/busi/custom/dictselect.vue'
import HsPlupload from '@/components/plupload/main.vue'
import dayjs from 'dayjs'
import idcardScan from '@/utils/idcardScan'

@Component({
  name: 'detailedit',
  components: {
    DictSelect,
    HsPlupload
  }
})

export default class DetailEdit extends Vue {
  get orderState () {
    return this.params.orderState === 3 ? 2 : this.params.orderState === 1 ? 1 : 3
  }

  private setting = setting

  private enterObj = {
    sex: '',
    name: '',
    nation: '',
    idcard: '',
    addr: ''
  }

  private loading = false

  private dayjs = dayjs

  get token () {
    return UserModule.token
  }

  @Prop({ type: Object })
  private params!: object|any

  private form = {}

  mounted () {
    this.initData()
  }

  private initData () {
    this.enterObj.sex = this.params.stuSex
    this.enterObj.nation = this.params.stuEthnic
    this.enterObj.name = this.params.stuName
    this.enterObj.idcard = this.params.stuPaperworkNumber
  }

  @Watch('params.stuName')
  private stuName () {
    this.params.stuName = this.params.stuName.replace(/(\u3000|\s)(\u3000|\s)*/g, '')
  }

  private rules = {
    stuName: [
      { required: true, message: '请输入名字', trigger: 'blur' }
    ],
    stuSex: [
      { required: true, message: '请选择性别', trigger: 'change' }
    ],
    stuEthnic: [
      { required: true, message: '请选择民族', trigger: 'change' }
    ],
    stuPhone: [
      { required: true, message: '请输入联系电话', trigger: 'blur' }
    ],
    stuPaperworkType: [
      { required: true, message: '请选择证件类型', trigger: 'change' }
    ],
    stuPaperworkNumber: [
      { required: true, message: '请输入证件号码', trigger: 'blur' }
    ]
  }

  // 1 id
  private image1s: any = this.params.atts[0] || { path: '' }
  private file1s = []
  private up1: any = {}

  private inputChange (queryDate: any) {
    if (queryDate === 'stuPaperworkNumber') {
      if (this.params.stuPaperworkNumber !== this.enterObj.idcard) {
        this.params.enter = 0
      }
    }

    if (queryDate === 'stuName') {
      if (this.params.stuName !== this.enterObj.name) {
        this.params.enter = 0
      }
    }
  }

  private sexChange () {
    if (this.enterObj.sex !== this.params.stuSex) {
      this.params.enter = 0
    }
  }

  private nationChange () {
    if (this.enterObj.nation !== this.params.stuEthnic) {
      this.params.enter = 0
    }
  }

  private inputUploader1 (up: any) {
    this.up1 = up
    this.file1s = up.files
  }

  private filesAdded1 (up: any, files: any) {
    if (files.length > 1) {
      this.$message.error('每次只允许选择一张图片')
      return
    }
    files.forEach((f: any) => {
      // eslint-disable-next-line handle-callback-err
      FileUrl(f.getNative(), (err: any, imgsrc: any) => {
        f.imgsrc = imgsrc
      })
    })
    if (up.files.length > 1) {
      up.removeFile(up.files[0])
    }
    up.start()
  }

  get file1Src () {
    this.params.file1Src = this.image1s.length > 0 ? this.image1s[0].path : this.params.atts[0].path
    return this.params.file1Src
  }

  private UploadComplete1 (up: any, files: any) {
    console.log(up, files)
  }

  private FileUploaded1 (up: any, files: any, res: any) {
    console.log(up, files, res)
    const response = JSON.parse(res.response)
    this.image1s = {
      path: response.fileInfos[0].savePath,
      name: response.fileInfos[0].savePath,
      realName: response.fileInfos[0].savePath,
      signupId: this.params.signupId,
      bigType: 0,
      createId: null,
      createTime: null,
      format: -1,
      memo: null,
      size: -1,
      smallType: 1,
      temName: '-1',
      updateId: null,
      updateTime: null
    }
    if (!this.params.atts || this.params.atts.length === 0) {
      this.params.atts = [this.image1s]
    } else {
      this.params.atts[0] = Object.assign(this.params.atts[0], this.image1s)
    }
  }

  private error1 (up: any, res: any) {
    this.$message.error(res.message)
  }

  // 2 id
  private image2s: any = this.params.atts[1] || { path: '' }
  private up2: any = {}
  private file2s = []

  private inputUploader2 (up: any) {
    this.up2 = up
    this.file2s = up.files
  }

  private filesAdded2 (up: any, files: any) {
    if (files.length > 1) {
      this.$message.error('每次只允许选择一张图片')
      return
    }
    files.forEach((f: any) => {
      // eslint-disable-next-line handle-callback-err
      FileUrl(f.getNative(), (err: any, imgsrc: any) => {
        f.imgsrc = imgsrc
      })
    })
    if (up.files.length > 1) {
      up.removeFile(up.files[0])
    }
    up.start()
  }

  private async UploadComplete2 (up: any, files: any) {
    this.loading = true
    const nationlist:any = (this.$refs.nation as any).list
    const cardInfo:any = await idcardScan(files[0].imgsrc)
    if (cardInfo.status === 200 && cardInfo.data.idcard_number_type === 1) {
      const wordsResult = cardInfo.data.words_result
      this.params.stuName = wordsResult['姓名'].words
      this.params.stuSex = (wordsResult['性别'].words === '男') ? 0 : 1
      this.params.stuAddress = wordsResult['住址'].words
      const natianName = wordsResult['民族'].words + '族'
      this.params.stuPaperworkNumber = wordsResult['公民身份号码'].words
      const nation = nationlist.filter((v: any) => v.nationName === natianName)
      if (nation) {
        this.params.stuEthnic = nation[0].nationKey
      }
      this.params.enter = 1
      this.loading = false
    } else {
      this.loading = false
    }
  }

  private FileUploaded2 (up: any, files: any, res: any) {
    console.log(up, files, res)
    const response = JSON.parse(res.response)
    this.image2s = {
      path: response.fileInfos[0].savePath,
      name: response.fileInfos[0].savePath,
      realName: response.fileInfos[0].savePath,
      signupId: this.params.signupId,
      bigType: 0,
      createId: null,
      createTime: null,
      format: -1,
      memo: null,
      size: -1,
      smallType: 2,
      temName: '-1',
      updateId: null,
      updateTime: null
    }

    if (!this.params.atts || this.params.atts.length === 0) {
      this.params.atts = [{
        path: '',
        name: '',
        realName: '',
        signupId: this.params.signupId,
        bigType: 0,
        createId: null,
        createTime: null,
        format: -1,
        memo: null,
        size: -1,
        smallType: 2,
        temName: '-1',
        updateId: null,
        updateTime: null
      }]
      this.params.atts.push(this.image2s)
    } else {
      this.params.atts[1] = Object.assign(this.params.atts[1], this.image2s)
    }
  }

  private error2 (up: any, res: any) {
    this.$message.error(res.message)
  }

  private validate (callback: Function) {
    (this.$refs.form as any).validate(() => {
      callback()
    })
  }
}
